module.exports = __webpack_public_path__ + "static/media/7.1.1. REGISTRO-DE-ACTIVOS DE LA INFORMACION NOTARIA.6670d796.pdf";